import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const faqFilters: (
  faqCategoryOptions: { label: string; value: string }[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = faqCategoryOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'faqCategoryType',
    label: '카테고리',
    placeholder: '전체',
    options: [{ label: '전체', value: '' }, ...faqCategoryOptions],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'showedYn',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.exposed, value: 'true' },
      { label: OPTIONS_CONST.notExposed, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'title',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'adminName',
    label: '등록 관리자',
    placeholder: '관리자명을 입력해주세요',
  },
];
